import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    padding: 8,
  },
  label: {},

  activeContainer: {
    backgroundColor: '#4285f4',
  },

  activeLabel: {
    color: 'white',
    fontWeight: 'bold',
  },

  disabledLabel: {
    color: '#dddddd',
  },
});
